namespace Areas {
    "use strict";
//TODO Check if needed
    // export function addToFavorite(e: any) {
    //     const dialog = new Areas.Dialogs.CreateFavoriteDialog(() => { }, { favoriteName: e.component.option("description") });
    // }


}